import { useState, useEffect } from "react"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, Checkbox, MoneyInput, NumberInput, Select, TextInput } from "../../components/forms/Inputs"
import { useApi } from "../../hooks/useApi"
import { useTranslations } from "../../layers/Localization"
import { useOptions } from "../../hooks/useOptions"
import { getTotalsFactureDetail } from "./FacturesDetail"
import { Currency } from "../../hooks/helpers"
import { useCodesTvaOptions } from "./Articles"

function NotesDeCreditDetailFields({ item, set }) {
    const codesTvaOptions = useCodesTvaOptions()
    const [noteDeCredit, setNoteDeCredit] = useState()

    const t = useTranslations()
    const api = useApi()
    const articleOptions = useOptions('articles', 'nom')
    const chantiersOptions = useOptions('chantiers', ['nom', 'descriptionFacture'], { query: noteDeCredit ? `clientId=${noteDeCredit.clientId}` : '' })

    useEffect(() => {
        if (item.notesDeCreditId) api.get(`/notesDeCredit/${item.notesDeCreditId}`).then(setNoteDeCredit)
    }, [item.notesDeCreditId])
    useEffect(() => {
        if (item.articleId) {
            api.get(`/articles/${item.articleId}`).then(article => {
                set('chantierId')(null)
                set('quantite')(1)
                set('prixUnitaire')(null)
                set('codeTva')(article.codeTva)
                set('nom')(article.nom)
            })
        }
    }, [item.articleId])
    useEffect(() => {
        if (item.chantierId) {
            api.get(`/chantiers/${item.chantierId}`).then(chantier => {
                set('articleId')(null)
                set('quantite')(1)
                set('prixUnitaire')(chantier.prixVente)
                set('codeTva')(chantier.codeTva)
                set('nom')(chantier.descriptionFacture)
            })
        }
    }, [item.chantierId])

    return <>
        <Row>
            <NumberInput label={t("Ordre")} value={item.ordre} onChange={set('ordre')} required />
            <AsyncSelect className="grow" label={t("Chantier")} value={item.chantierId} onChange={set('chantierId')} options={chantiersOptions} />
            <AsyncSelect className="grow" label={t("Article")} value={item.articleId} onChange={set('articleId')} options={articleOptions} />
        </Row>
        <TextInput label={t("Désignation")} value={item.nom} onChange={set('nom')} required />
        <Row>
            <NumberInput label={t("Quantité")} value={item.quantite} onChange={set('quantite')} required min={item.exportPopsy ? "1" : "0"} />
            <MoneyInput label={t("Prix unitaire")} value={item.prixUnitaire} onChange={set('prixUnitaire')} required min={item.exportPopsy ? "0.01" : "0"} />
            <Select label={t("Code TVA")} value={item.codeTva} onChange={set('codeTva')} options={codesTvaOptions} required />
        </Row>
        <Checkbox label={t("Export Popsy")} value={item.exportPopsy} onChange={set('exportPopsy')} />
        <Row>
            <MoneyInput className="grow" label={t("Total HTVA")} value={getTotalsFactureDetail(item, codesTvaOptions).totalHtva} disabled />
            <MoneyInput className="grow" label={t("Total TVA")} value={getTotalsFactureDetail(item, codesTvaOptions).totalTva} disabled />
            <MoneyInput className="grow" label={t("Total TTC")} value={getTotalsFactureDetail(item, codesTvaOptions).totalTtc} disabled />
        </Row>
    </>
}

export function NotesDeCreditDetailList(props) {
    const codesTvaOptions = useCodesTvaOptions()
    const t = useTranslations()

    return <ListPage model="notesDeCreditDetail" title={t("Détails")} columns={{
        [t('Ordre')]: 'ordre',
        [t('Désignation')]: 'nom',
        [t('Quantité')]: 'quantite',
        [t('Prix unitaire')]: { sort: 'prixUnitaire', value: item => <Currency value={item.prixUnitaire} /> },
        [t('Code TVA')]: { sort: 'codeTva', value: item => <FkLink>{codesTvaOptions.find(x => x.value === item.codeTva).label}</FkLink> },
        [t('Total HTVA')]: { value: item => <Currency value={getTotalsFactureDetail(item, codesTvaOptions).totalHtva} /> },
        [t('Total TTC')]: { value: item => <Currency value={getTotalsFactureDetail(item, codesTvaOptions).totalTtc} /> },
    }} {...props} />
}

export function NotesDeCreditDetailDetail(props) {
    const t = useTranslations()
    return <DetailPage model="notesDeCreditDetail" title={t("Détail")} Fields={NotesDeCreditDetailFields} defaults={{
        ordre: 0,
        quantite: 0,
        prixUnitaire: 0
    }}  {...props} />
}
